/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   handleMapUpdate thunk
 */

import type { RouteComponentProps } from 'react-router-dom'
import type { BoundsObj } from '../../../types'
import { showMarkers } from '../../currentSearchView/actions'
import type { Dispatch } from '../../types'
import { updateBox } from '../actions'
import { shouldSyncMapChange } from './shouldSyncMapChange'
import { syncMapChange } from './syncMapChange'

interface MapUpdateProps {
  bounds?: BoundsObj
  routeProps: Pick<RouteComponentProps, 'location'>
  skipSyncCheck?: boolean
}

export const handleMapUpdate =
  ({ bounds, routeProps, skipSyncCheck }: MapUpdateProps) =>
  (dispatch: Dispatch) => {
    bounds && dispatch(updateBox(bounds))

    const isMapSyncNecessary = dispatch(shouldSyncMapChange(routeProps, skipSyncCheck))

    if (isMapSyncNecessary) {
      dispatch(syncMapChange())
    } else {
      dispatch(showMarkers())
    }
  }
